import React, { useEffect, useState } from 'react';
import { Wrapper, NotificationWrapper, ListContainer, ListValueContainer } from "./NotificationPanel.styled";
import { Checkbox, Modal, Popover, Select, DatePicker } from 'antd';
import { AiOutlinePlus } from "react-icons/ai";
import { BsLink } from "react-icons/bs";
import { MdSend } from "react-icons/md";
import { callGetApi, callGetApiWithAuth, callPostApiWithAuth } from 'utils/api';
import systemImage from "../../assets/images/monitor.png";
import defaultUserImage from "../../assets/images/user.png";
import { ErrorNotification, SuccessNotification } from 'components/common';
import { useDispatch } from 'react-redux';
import moment from "moment";

const { Option } = Select;

const NotificationCustomStyle = {
    popoverContainerStyles: {
        display: 'flex', flexDirection: 'column', padding: '10px'
    },
    popoverContainerInputStyles: {
        border: '1px solid #cccccc',
        borderRadius: '5px',
        width: '100%',
        padding: '0 10px',
        outline: 'none',
        marginBottom: '10px'
    },
    linkDialogContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flex: 1,
        gap: 10
    },
    linkDialogInput: {
        border: '1px solid #ccc',
        width: '100%',
        borderRadius: '5px',
        padding: '0 10px',
    },
    linkDialogTitle: {
        fontSize: '16px',
        fontWeight: '600',
        letterSpacing: '1px'
    },
    taskContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flex: 1,
        gap: 20
    },
    taskSubContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        width: '100%',
        gap: 10
    },
    taskDialogTitle: {
        fontSize: '16px',
        fontWeight: '600',
        letterSpacing: '1px'
    },
    taskDialogSelectValue: {
        color: '#646464',
        fontWeight: '600',
        letterSpacing: '1px'
    }
}

const NotificationPanel = () => {
    const dispatch = useDispatch();
    const NOTIFICTION_TYPE = { noti: 'Notification', msg: 'Message', tsk: 'Task' }
    const tabs = [{ name: "Notification", key: 'noti' }, { name: 'Message', key: 'msg' }, { name: 'Task', key: 'tsk' }]
    const [currentKey, setCurrentKey] = useState('noti');
    const [notiData, setNotiData] = useState([]);
    const [msgData, setMsgData] = useState([]);
    const [taskData, setTaskData] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [users, setUsers] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [searchKeyword, setSearchKeyword] = useState('');
    const [message, setMessage] = useState('');
    const [link, setLink] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [frequency, setFrequency] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const FREQUENCY = [
        {
            label: "Daily",
            value: "daily",
        },
        {
            label: "Weekly",
            value: "weekly",
        },
        {
            label: "Monthly",
            value: "monthly",
        },
    ];
    const disabledDate = (current) => {
        return current && current < startDate;
    }
    const showModalTask = () => {
        setIsTaskModalOpen(true);
    };
    const handleOkTask = () => {
        setIsTaskModalOpen(false);
    };
    const handleCancelTask = () => {
        setIsTaskModalOpen(false);
        setFrequency('daily')
        setStartDate(null)
        setEndDate(null);
    };
    const showModalLink = () => {
        setIsModalOpen(true);
    };
    const handleOkLink = () => {
        setIsModalOpen(false);
    };
    const handleCancelLink = () => {
        setLink("");
        setIsModalOpen(false);
    };
    const changeTab = (key) => {
        setCurrentKey(key)
        if (key === 'noti') {
            notificationData();
        }
        if (key === 'msg') {
            messageTaskGetApi();
        }
        if (key === 'tsk') {
            setFrequency('daily');
            gettask();
        }
    }
    const onChange = (selection) => {
        if (selection.includes('all')) {
            setSelectedItems(['all']);
            setInputValue('All Users');
        } else {
            setSelectedItems([...selection]);
            updateInputValue(selection);
        }
    };
    const searchUser = (e) => {
        const { value } = e.target;
        setSearchKeyword(value);
        if (!value) {
            setUsers(allUsers);
        } else {
            const userss = allUsers.filter((e) => e.name.toLocaleLowerCase().includes(value.toLocaleLowerCase()));
            setUsers(userss)
        }
    }
    const updateInputValue = (selection) => {
        if (selection.length) {
            const filterUsers = allUsers.filter((e) => selection.includes(e.id)).map((e) => e.name)
            setInputValue(filterUsers.join(', '))
        } else {
            setInputValue('')
        }
    }
    const CheckboxRender = () => {
        return (
            <Checkbox.Group onChange={onChange} value={selectedItems}>
                <ListContainer>
                    <ListValueContainer key={"checkbox-group-all"}>
                        <Checkbox
                            key={"checkbox-group-all-aallll"}
                            value={"all"}
                            className='checkbox-cont'
                        >
                            All
                        </Checkbox>
                    </ListValueContainer>
                    {users.map((group, i) => {
                        return (
                            <ListValueContainer key={"checkbox-group-" + i}>
                                <Checkbox
                                    key={group.id}
                                    value={group.id}
                                    className='checkbox-cont'
                                    disabled={selectedItems[0] === 'all'}
                                >
                                    {group.name}
                                </Checkbox>
                            </ListValueContainer>
                        );
                    })}
                </ListContainer>
            </Checkbox.Group>
        )
    }
    const onSend = () => {
        if (!selectedItems.length || !message) {
            ErrorNotification("Please Fill the Requried Feilds.")
            return;
        }
        if (currentKey === 'tsk' && (!frequency || !startDate || !endDate)) {
            ErrorNotification("Please create a task by pressing on plus icon.")
            return;
        }

        const payload = {
            message: message,
            type: NOTIFICTION_TYPE[currentKey],
            sendTo: selectedItems[0] === 'all' ? 'all' : 'user',
            link: link || '',
            recep: selectedItems[0],
            sender: 'MySelf',
            dismissed: false,
            isMessage: currentKey === 'msg' ? true : false,
        }
        if (currentKey === 'tsk') {
            payload.frequency = frequency;
            payload.startDate = startDate.toDate();
            payload.endDate = endDate.toDate()
        }
        callPostApiWithAuth('/notification', payload, () => {
            SuccessNotification(`${NOTIFICTION_TYPE[currentKey]} sent successfully.`);
            if (currentKey === 'noti') {
                notificationData(true);
            }
            if (currentKey === 'msg') {
                messageTaskGetApi(true);
            }
            if (currentKey === 'tsk') {
                gettask();
            }
            setMessage('');
            setLink('');
            setSelectedItems([]);
            setFrequency(null);
            setStartDate(null);
            setEndDate(null);
            setSearchKeyword('');
            setInputValue('');
        }, (err) => {
            console.log(err);
        })
    }
    const getUserData = () => {
        callGetApi("/user", (data) => {
            let dd = data.map((d) => ({ id: d._id, name: d.username }));
            setUsers(dd);
            setAllUsers(dd);
        }, () => { });
    };
    const notificationData = (force = false) => {
        if (!notiData.length || force) {
            callGetApiWithAuth("/notification/all/notifications", (data) => {
                setNotiData(data);
            }, () => { });
        }
    };
    const messageTaskGetApi = (force = false) => {
        if (!msgData.length || force) {
            callGetApiWithAuth("/notification/all/messages", (data) => {
                setMsgData(data);
            }, () => { });
        }
    };
    const gettask = (force = false) => {
        if (!taskData.length || force) {
            callGetApiWithAuth("/notification/all/tasks", (data) => {
                setTaskData(data)
            }, () => { });
        }
    };

    useEffect(() => {
        getUserData();
        notificationData();
    }, [])

    return (
        <Wrapper>
            <NotificationWrapper>
                <div className="top-tabs">
                    {tabs.map((tab) => (
                        <div key={tab.key} className={`tab${currentKey === tab.key ? ' active' : ''}`} onClick={() => changeTab(tab.key)}>{tab.name}</div>
                    ))}
                </div>
                <div className="input-container">
                    {allUsers && allUsers.length ? (
                        <Popover
                            content={
                                <div className='popover-content-container' style={NotificationCustomStyle.popoverContainerStyles}>
                                    <input type="text" placeholder='Search...' value={searchKeyword} style={NotificationCustomStyle.popoverContainerInputStyles} onChange={searchUser} />
                                    <CheckboxRender />
                                </div>
                            }
                            trigger="click"
                            placement="bottomLeft"

                        >
                            <input type="text" className='input' value={inputValue} disabled={true} />
                            <span className='texto'>To:</span>
                        </Popover>
                    ) : null}
                </div>

                <div className="body-container">
                    {currentKey === 'noti' && (
                        <div className="content">
                            {notiData && notiData.length ? (
                                <>
                                    {
                                        notiData.map((data) => (
                                            <div className='msg-div'>
                                                <div className="start">
                                                    <img
                                                        src={
                                                            data?.sender === "SYSTEM"
                                                                ? systemImage
                                                                : data?.sender.avatar === null
                                                                    ? defaultUserImage
                                                                    : `${data?.sender?.avatar}`
                                                        }
                                                        alt="..."
                                                        className="avatar"
                                                    />
                                                    <div className="sender">
                                                        <div className="sender-name">{data?.sender === "SYSTEM" ? "System" : `${data?.sender?.name}`}</div>
                                                        <div className="message">{data?.message}</div>
                                                    </div>
                                                </div>
                                                <div className="end">
                                                    {moment(data?.createdAt).fromNow()}
                                                </div>
                                            </div>
                                        ))
                                    }
                                </>
                            ) : null}
                        </div>
                    )}
                    {currentKey === 'msg' && (
                        <div className="content">
                            {msgData && msgData.length ? (
                                <>
                                    {
                                        msgData.map((data) => (
                                            <div className='msg-div'>
                                                <div className="start">
                                                    <img
                                                        src={
                                                            data?.sender === "SYSTEM"
                                                                ? systemImage
                                                                : data?.sender.avatar === null
                                                                    ? defaultUserImage
                                                                    : `${data?.sender?.avatar}`
                                                        }
                                                        alt="..."
                                                        className="avatar"
                                                    />
                                                    <div className="sender">
                                                        <div className="sender-name">{data?.sender === "SYSTEM" ? "System" : `${data?.sender?.name}`}</div>
                                                        <div className="message">{data?.message}</div>
                                                    </div>
                                                </div>
                                                <div className="end">
                                                    {moment(data?.createdAt).fromNow()}
                                                </div>
                                            </div>
                                        ))
                                    }
                                </>
                            ) : null}
                        </div>
                    )}
                    {currentKey === 'tsk' && (
                        <div className="content">
                            {taskData && taskData.length ? (
                                <>
                                    {
                                        taskData.map((data) => (
                                            <>
                                                {
                                                    taskData.map((data) => (
                                                        <div className='msg-div'>
                                                            <div className="start">
                                                                <img
                                                                    src={
                                                                        data?.sender === "SYSTEM"
                                                                            ? systemImage
                                                                            : data?.sender.avatar === null
                                                                                ? defaultUserImage
                                                                                : `${data?.sender?.avatar}`
                                                                    }
                                                                    alt="..."
                                                                    className="avatar"
                                                                />
                                                                <div className="sender">
                                                                    <div className="sender-name">{data?.sender === "SYSTEM" ? "System" : `${data?.sender?.name}`}</div>
                                                                    <div className="message">Start At: {moment(data?.startAt).format('DD/MM/YYYY')}, End At: {moment(data?.endDate).format('DD/MM/YYYY')}, Frequency: {data?.frequency}</div>
                                                                </div>
                                                            </div>
                                                            <div className="end">
                                                                {moment(data?.createdAt).format('DD/MM/YYYY')}
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </>
                                        ))
                                    }
                                </>
                            ) : null}
                        </div>
                    )}
                </div>

                <div className="send-container">
                    <div className="hr"></div>
                    <input type="text" placeholder='Type Here!' className='input-send' value={message} onChange={(e) => setMessage(e.target.value)} />
                    <div className="icons">
                        <div className="add-link-icon">
                            {currentKey === 'tsk' && (<AiOutlinePlus size={16} onClick={showModalTask} />)}
                            <BsLink size={16} onClick={showModalLink} />
                        </div>
                        <div className="send-icon">
                            <MdSend size={18} onClick={onSend} />
                        </div>
                    </div>
                </div>
            </NotificationWrapper>
            <Modal title="Attach Links" open={isModalOpen} onOk={handleOkLink} onCancel={handleCancelLink} >
                <div style={NotificationCustomStyle.linkDialogContainer}>
                    <div style={NotificationCustomStyle.linkDialogTitle}>Paste your Link Here:</div>
                    <input type="text" style={NotificationCustomStyle.linkDialogInput} value={link} onChange={(e) => setLink(e.target.value)} />
                </div>
            </Modal>
            <Modal title="Create Task" open={isTaskModalOpen} onOk={handleOkTask} onCancel={handleCancelTask} >
                <div style={NotificationCustomStyle.taskContainer}>
                    <div style={NotificationCustomStyle.taskSubContainer}>
                        <div style={NotificationCustomStyle.taskDialogTitle}>Select Frequency:</div>
                        <Select
                            defaultValue={frequency}
                            value={frequency}
                            style={{ width: "100%" }}
                            onChange={(e) => setFrequency(e)}
                        >
                            {FREQUENCY.map((fre) => (
                                <Option key={fre.value} value={fre.value}>
                                    <span style={NotificationCustomStyle.taskDialogSelectValue}>{fre.label}</span>
                                </Option>
                            ))}
                        </Select>
                    </div>
                    <div style={NotificationCustomStyle.taskSubContainer}>
                        <div style={NotificationCustomStyle.taskDialogTitle}>Select Start Date:</div>
                        <DatePicker style={{ width: "100%" }} value={startDate || moment(new Date())} onChange={(e) => {
                            setStartDate(e);
                            setEndDate(e);
                        }} />
                    </div>
                    <div style={NotificationCustomStyle.taskSubContainer}>
                        <div style={NotificationCustomStyle.taskDialogTitle}>Select End Date:</div>
                        <DatePicker style={{ width: "100%" }} disabledDate={disabledDate} value={endDate || moment(new Date())} onChange={(e) => {
                            setEndDate(e);
                        }} disabled={!startDate} />
                    </div>
                </div>
            </Modal>
        </Wrapper>
    )
}

export default NotificationPanel
